import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommunityBoardListasyncReqPros, CommunityBoardListInitialState } from "../model/CommunityBoardListReducerType";

const reducerId = "CommunityBoardListReducer/asyncReqCommunityBoardList";
const controllerMap = new Map();

const initialState: CommunityBoardListInitialState = {
    status: "",
    currPage: 1,
    n4ErrorCode: 0,
    strErrorMessage: "",
    n4CurrCount: 0,
    n4TotalCount: 0,
    n4TotalPage: 0,
    LIST: []
};

const slice = createSlice({
    name: "CommunityBoardListReducer",
    initialState,
    reducers: {
        setCurrPage: (state, action) => {
            state.currPage = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(asyncReqCommunityBoardList.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqCommunityBoardList.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.n4CurrCount = action.payload.n4CurrCount;
            state.n4TotalCount = action.payload.n4TotalCount;
            state.n4TotalPage = action.payload.n4TotalPage;
            state.LIST = action.payload.LIST;
        });
        builder.addCase(asyncReqCommunityBoardList.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqCommunityBoardList = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        CommunityBoardListasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ page_size, curr_page, search_type = "", search_keyword = "", sub_menu = "" }: CommunityBoardListasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/CommunityBoardList.aspx?page_size=${page_size}&curr_page=${curr_page}&search_type=${encodeURIComponent(search_type)}&search_keyword=${encodeURIComponent(search_keyword)}&sub_menu=${encodeURIComponent(sub_menu)}`,
                {
                    signal: controller.signal,
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const CommunityBoardListActions = slice.actions;
export default slice.reducer;